module.exports = __webpack_public_path__ + "img/Plantas rebaixadas e com retirada de ramos laterais 4.07c971aa.webp";